// extracted by mini-css-extract-plugin
export default {"timeSelector":"TimeSelector_timeSelector__4UQdS"};